import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services*/
import { ServicesService, StateService, ScreenService, TariffService, CachedDataService } from '@services';

/*Models */
import { Device, Service, Tariff, ObservableObject, OrderItem } from '@models';

/*Plugins */
import * as moment from 'moment';


/*Config*/
import { CONFIG } from '../../config';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})

export class ServicesComponent implements OnInit, OnDestroy{
    @ViewChild('tariffModal') tariffModal;
    @ViewChild('serviceOrderModal') serviceOrderModal;
    servicesList: Array<Service>;
    selectedService: Service;
    curentUser;
    tariffList: Array<Tariff>;
    ifLoadingData = false;
    observableObjects: Array<ObservableObject>;
    ordersList: Array<OrderItem> = null;
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    private currentDevice: Device;
    private intervalGetOrders= null;

    constructor(private servicesService: ServicesService, private stateService: StateService, private screenService: ScreenService, private tariffService: TariffService, private cachedDataService: CachedDataService){
        this.stateService.currentDeviceObservable
            .takeUntil(this.ngUnsubscribe)
            .subscribe(device => {
                this.currentDevice = device;
                this.getServices();
            });
            this.curentUser = this.cachedDataService.getCurrentUser();
            this.observableObjects = this.cachedDataService.getObservableObjects();
            
    }

    ngOnInit(){
        this.screenService.isStateHidden = true;
    }

    getServices() {

       
        this.servicesService.getServices(this.currentDevice.id)
            .subscribe(response => {
                if(response && response.length){
                    this.servicesList = response
                }else{
                    this.servicesList = [];
                }
              
                console.log(response)
                this.screenService.isDataLoadingSubject.next(false);
            },
            error => {
                alert("Ошибка, попробуйте позже")
                this.servicesList = [];
                this.screenService.isDataLoadingSubject.next(false);
                console.log(error);
            }
          );
    }
    selectService(service: Service){
        this.selectedService = service;
        this.ifLoadingData = true;
        switch (service.serviceType) {
            case 'prolongation': {
                this.getTarifs();
                break;
            }
            case 'osago': {
                this.ifLoadingData = false;
                setTimeout(()=>{
                    this.loadScriptOsago(this.selectedService.parameters.osagoWidgetJsContent);
                })
                
                break;
            }
            case 'freezing': {
                console.log(this.observableObjects)
                this.getTarifs();
                this.getSerivecesOrders();
                this.ifLoadingData = false;
              
                
                break;
            }
            case "roaming": {
                this.getTarifs();
                this.getSerivecesOrders();
                this.ifLoadingData = false;
              
                
                break;
            }
        }
    }

    loadScriptOsago(url: string) {
        

        const script = document.createElement('script');
        script.innerHTML = '';


         
        let urlArray = url.replace("<script ", "").replace("></script>", "").split(" ");
        urlArray.map(item=>{
            let itemArray = item.replace(/'/g, "").split("=");
            if(itemArray[0]=="src"){
                script.src = itemArray[1];
                script.async = false;
                script.defer = true;
            }else{
                if(itemArray[0]=="data-aff_sub2"){
                    itemArray[1]=JSON.stringify([this.cachedDataService.getCurrentUser().id])
                }
                if(itemArray[0]=="data-size"){
                    itemArray[1]="356";
                }
                script.setAttribute(itemArray[0], itemArray[1]);
            }
               
        });
        document.getElementById('osago-container').appendChild(script);
    }

    getTarifs(){
        this.tariffService.getInfoSim(this.curentUser.id)
            .subscribe(response => {
                if (response.data && response.data.length) {
                    this.tariffList = [];
                    response.data.map(tarif=>{
                        //добавляем для выбора
                        tarif.selected = false;
                    })
                    
                  
                   
                    this.observableObjects.map(object => {
                        object.devices.map(device => {
                            //перебираем все устройства и находим у кого есть тариф
                        if(this.tariffService.getTariff(response.data, device)){
                            let tariff: Tariff = this.tariffService.getTariff(response.data, device);
                            tariff = JSON.parse(JSON.stringify(tariff))

                            //добавляем название устройства в тариф для вывода
                            tariff["observableObjectName"] = object.name;
                           this.tariffList.push(tariff)
                        }
                        });
                    });
                    if( this.selectedService.serviceType=="freezing"){
                        //this.serviceSendTarifModal.open(this.tariffList)
                    }
                }else{
                    alert("Ошибка при получении тарифов")
                }

                this.ifLoadingData = false;
            },
            error => {
                this.ifLoadingData = false;
                alert("Ошибка при получении тарифов")
                console.log(error);
            }
            );
    }
    getSerivecesOrders(notRunInterval?:boolean){
        this.tariffService.getSerivecesOrders(this.selectedService.serviceType, this.curentUser.id)
            .subscribe(response => {
                if(response && response.data && response.data.length){
                    response.data.map(item=>{
                        if(item.startServiceDate){
                            item["fromFormat"] = moment(item.startServiceDate*1000).format('DD.MM.YYYY');
                        }
                        if(item.endServiceDate){
                            item["toFormat"] = moment(item.endServiceDate*1000).format('DD.MM.YYYY');
                        }
                       
                       
                        item.statusText =  CONFIG.orderStatus[item.clientStatus] ? CONFIG.orderStatus[item.clientStatus] : item.clientStatus
                        if(!notRunInterval){
                            this.startUpdateOrder()
                        }
                        
                       
                    })
                    console.log(response.data)
                    this.ordersList = response.data;
                }else{
                    this.ordersList = [];
                }
              console.log(response)
            },
            error => {
                this.ifLoadingData = false;
                alert("Ошибка при запросе заявок, попробуйте позже")
                console.log(error);
            }
            );
    }
    startUpdateOrder(){
        if (this.intervalGetOrders && this.intervalGetOrders != null) {
            clearInterval(this.intervalGetOrders);
        }
        this.intervalGetOrders = setInterval(()=> {
            this.getSerivecesOrders()
        }, 5000);
    }
    ifHasSelectedObject(list: Array<any>){
       if(list &&  list.filter(item=>item.selected).length){
           return true;
       }else{
           return false;
       }
    }

    openTariffModal() {
        this.tariffModal.open(this.tariffList.filter(tariff=>tariff.selected));
    }

    openSendOrderModal(){
        this.serviceOrderModal.open(this.tariffList,  this.selectedService);
    }

    clearService(){
        this.ifLoadingData = false;
        this.tariffList = null;
        this.selectedService = null;
        if (this.intervalGetOrders && this.intervalGetOrders != null) {
            clearInterval(this.intervalGetOrders);
        }
    }
    ngOnDestroy(){
        if (this.intervalGetOrders && this.intervalGetOrders != null) {
            clearInterval(this.intervalGetOrders);
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/view/services/services.component.ts